import { actionTypes } from '../actioncreators/actioncreators'
import { hosts } from '../hostAdapters/hosts'

let initialState = {
  saveCounter: 0,
  host: hosts.STANDALONE,
  displayExportDialogue: false,
  displayFeedbackDialogue: false,
  summary: '',
  issueKey: '',
  loading: true
}

export const GeneralReducer = (currentState = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_HOST:
      return Object.assign({}, currentState, { host: action.value })
    case actionTypes.INCREMENT_SAVE_COUNTER:
      return Object.assign({}, currentState, { saveCounter: currentState.saveCounter + 1 })
    case actionTypes.DECREMENT_SAVE_COUNTER:
      return Object.assign({}, currentState, { saveCounter: currentState.saveCounter - 1 })
    case actionTypes.CLOSE_EXPORT_DIALOGUE:
      return Object.assign({}, currentState, { displayExportDialogue: false })
    case actionTypes.OPEN_EXPORT_DIALOGUE:
      return Object.assign({}, currentState, { displayExportDialogue: true })
    case actionTypes.OPEN_FEEDBACK_DIALOGUE:
      return Object.assign({}, currentState, { displayFeedbackDialogue: true })
    case actionTypes.CLOSE_FEEDBACK_DIALOGUE:
      return Object.assign({}, currentState, { displayFeedbackDialogue: false })
    case actionTypes.LOAD_SUMMARY:
      return Object.assign({}, currentState, { summary: action.data })
    case actionTypes.LOAD_ISSUE_KEY:
      return Object.assign({}, currentState, { issueKey: action.data })
    case actionTypes.LOAD_EXAMPLE_MAP:
      return Object.assign({}, currentState, { loading: false })
    default:
      return currentState
  }
}

export default GeneralReducer
